import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../hook/useAuth";
import { useEffect, useState } from "react";
import { getLocation } from "../../../services/Location";
import axios from "axios";
import { baseURL } from "../../../config/api";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";
import EmailValidatedToCheckExistComponent from "../../../components/EmailValidatedToCheckExistComponent";
import { DoesEmailExist } from "../../../services/Users";
import useConfirm from "../../../hook/useConfirm";
import useDelete from "../../../hook/useDelete";
import { formatUSPhone, getUSPhoneDigits } from "../../../utils/phoneFormatter";
import { validateMin } from "../../../utils/validateMin";
import { delete_comment, getCommentsReportByAttributeAndAttributeId, getStatus, post_comment } from "../../../services/Appointment";
import AddComments from "./AddComments";


type CommentType = {
    id: number;
    attributeName: string;
    attributeId: string;
    notes: string;
    userName: string;
    createdDate: string;
};


export const EditVendor = () => {
    const navigate = useNavigate();
    const idNumber = useLocation();
    const { auth }: any = useAuth();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [statusOptions, setStatusOptions] = useState<any[]>([]);
    const [statusId, setStatusId] = useState<number>(0);
    const [vendorData, setVendorData] = useState<any>(null);
    const [locationId, setLocationId] = useState<number>(0);
    const [vendorName, setVendorName] = useState<string>("");
    const [address1, setAddress1] = useState<string>("");
    const [address2, setAddress2] = useState<string>("");
    const [city, setCity] = useState<string>("");
    const [state, setState] = useState<string>("");
    const [zipCode, setZipCode] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [isPhoneValid, setIsPhoneValid] = useState<boolean>(false);
    const [fax, setFax] = useState<string>("");
    const [vendorTaxID, setVendorTaxID] = useState<string>("");
    const [vendorTerms, setVendorTerms] = useState<string>("");
    const [county, setCounty] = useState<string>("");
    const [country, setCountry] = useState<string>("");
    const [commission, setCommission] = useState<number>(0);
    const [rent, setRent] = useState<number>(0);
    const [contactPerson1, setContactPerson1] = useState<string>("");
    const [contactPerson1Phone, setContactPerson1Phone] = useState<string>("");
    const [isContact1PhoneValid, setIsContact1PhoneValid] = useState<boolean>(false);
    const [contactPerson2, setContactPerson2] = useState<string>("");
    const [contactPerson2Phone, setContactPerson2Phone] = useState<string>("");
    const [isContact2PhoneValid, setIsContact2PhoneValid] = useState<boolean>(false);
    const [website, setWebsite] = useState<string>("");
    const [minimumOrder, setMinimumOrder] = useState<number>(0);
    const [defaultOrderingMode, setDefaultOrderingMode] = useState<string>("");
    const [defaultBillableDepartment, setDefaultBillableDepartment] = useState<string>("");
    const [defaultPODelivery, setDefaultPODelivery] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [emailTouched, setEmailTouched] = useState<boolean>(false);
    const [comments, setComments] = useState<string>("");
    const [saveCommentsValue, setSaveCommentsValue] = useState([]);
    const [isComment, setIsComment] = useState(0);
    const [deliveryTime, setDeliveryTime] = useState<string>("");
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    useEffect(() => {
        getLocation()
            .then((data) => {
                setLocationOptions(() => data?.map((loc: any) => {
                    return {
                        value: loc?.id,
                        label: loc?.locationName
                    }
                }))


            })
            .catch((error) => {
                console.error(error)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        getStatus("Vendor")
            .then((data) => {
                setStatusOptions(() => data?.map((status: any) => {
                    return {
                        value: status?.statusID,
                        label: status?.statusValue
                    }
                }))


            })
            .catch((error) => {
                console.error(error)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (phone?.trim() !== "") {
            timer = setTimeout(() => {
                const valid = /^\d{10}$/.test(phone);
                setIsPhoneValid(valid);
            }, 500);
        } else {
            setIsPhoneValid(true);
        }

        return () => clearTimeout(timer);
    }, [phone]);

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (contactPerson1Phone?.trim() !== "") {
            timer = setTimeout(() => {
                const valid = /^\d{10}$/.test(contactPerson1Phone);
                setIsContact1PhoneValid(valid);
            }, 500);
        } else {
            setIsContact1PhoneValid(true);
        }

        return () => clearTimeout(timer);
    }, [contactPerson1Phone]);


    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (contactPerson2Phone?.trim() !== "") {
            timer = setTimeout(() => {
                const valid = /^\d{10}$/.test(contactPerson2Phone);
                setIsContact2PhoneValid(valid);
            }, 500);
        } else {
            setIsContact2PhoneValid(true);
        }

        return () => clearTimeout(timer);
    }, [contactPerson2Phone]);

    useEffect(() => {
        getCommentsReportByAttributeAndAttributeId("Vendor", parseInt(idNumber.state))
            .then(data => {
                setSaveCommentsValue(data)
            })
            .catch(error => {
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isComment]);

    useEffect(() => {
        if (idNumber?.state) {
            setPleaseWaitPopup(true);
            axios
                .get(`${baseURL}vendors/${idNumber?.state}`)
                .then((response) => {
                    setVendorData(response?.data)
                    setLocationId(response?.data?.locationId)
                    setVendorName(response?.data?.vendorName)
                    setStatusId(response?.data?.statusId)
                    setAddress1(response?.data?.address1)
                    setAddress2(response?.data?.address2)
                    setCity(response?.data?.city)
                    setState(response?.data?.state)
                    setZipCode(response?.data?.zipCode)
                    setPhone(response?.data?.phone)
                    setFax(response?.data?.fax)
                    setEmail(response?.data?.email)
                    setVendorTaxID(response?.data?.vendorTaxID)
                    setVendorTerms(response?.data?.vendorTerms)
                    setCountry(response?.data?.country)
                    setCounty(response?.data?.county)
                    setCommission(response?.data?.commission)
                    setRent(response?.data?.rent)
                    setContactPerson1(response?.data?.contactPerson1)
                    setContactPerson1Phone(response?.data?.contactPerson1Phone ? response?.data?.contactPerson1Phone : "")
                    setContactPerson2(response?.data?.contactPerson2)
                    setContactPerson2Phone(response?.data?.contactPerson2Phone ? response?.data?.contactPerson2Phone : "")
                    setWebsite(response?.data?.website)
                    setMinimumOrder(response?.data?.minimumOrder)
                    setDefaultOrderingMode(response?.data?.defaultOrderingMode)
                    setDefaultBillableDepartment(response?.data?.defaultBillableDepartment)
                    setDefaultPODelivery(response?.data?.defaultPODelivery)
                    setDeliveryTime(response?.data?.deliveryTime)
                    setPleaseWaitPopup(false);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber])

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setPleaseWaitPopup(true);

        await axios
            .put(
                `${baseURL}vendors?userId=${auth?.id}`,
                JSON.stringify({
                    vendorId: idNumber?.state,
                    locationId,
                    vendorName,
                    statusId,
                    address1,
                    address2,
                    city,
                    state,
                    zipCode,
                    phone,
                    fax,
                    vendorTaxID,
                    vendorTerms,
                    county,
                    country,
                    email,
                    commission,
                    rent,
                    contactPerson1,
                    contactPerson1Phone,
                    contactPerson2,
                    contactPerson2Phone,
                    website,
                    deliveryTime,
                    minimumOrder,
                    defaultOrderingMode,
                    defaultBillableDepartment,
                    defaultPODelivery,
                    createdAt: vendorData?.createdAt,
                    createdBy: vendorData?.createdBy,
                    updatedAt: new Date().toLocaleString(),
                    updatedBy: auth?.givenname,
                }),
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: false,
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error("Error:", error);
            });
    }

    const saveComments = () => {
        if (!comments?.trim()) {
            return;
        }
        setPleaseWaitPopup(true);

        post_comment(
            {
                attributeName: "Vendor",
                attributeId: idNumber.state,
                notes: comments,
                userId: auth?.id,
                createdDate: new Date().toLocaleString(),
            }, auth?.id)
            .then(() => {
                setComments("");
                setIsComment(isComment + 1);
                setPleaseWaitPopup(false);

            })
            .catch((error) => {
                setPleaseWaitPopup(false);
                console.error(error)
            });
    };


    const deletingVendor = async () => {
        setDeleteData({
            id: idNumber?.state,
            title: `Delete User`,
            summary: `Are you sure you want to delete this vendor?`,
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);
                callback();

                axios
                    .delete(`${baseURL}vendors?id=${idNumber?.state}&userId=${auth?.id}`)
                    .then(() => {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                    })
                    .catch((error) => {
                        setConfirmData({
                            title: "Warning",
                            summary: error.response?.data || "Delete failed.",
                            confirmBtn: "Ok",
                            isConfirm: (cb: any) => cb(),
                        });

                        setConfirmPopup(true);
                        setPleaseWaitPopup(false);
                    });
            },
        });

        setDeletePopup(true);
    }

    const deleteTheComment = async (id: number) => {
        setDeleteData({
            id: id,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this comment?`,
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);
                callback();
                delete_comment(id, auth?.id)
                    .then(() => {
                        setSaveCommentsValue(saveCommentsValue.filter((item: any) => item.id !== id))
                        setPleaseWaitPopup(false);

                    })
                    .catch((error) => {
                        console.error(error)
                    });
            }
        });
        setDeletePopup(true);
    }


    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <h2 className={`text-lg font-semibold`}>Edit Vendor</h2>

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full flex justify-between">
                                <div className="w-[55%] grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Vendor Name<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={vendorName}
                                                placeholder="Vendor Name"
                                                onChange={(e) => setVendorName(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <EmailValidatedToCheckExistComponent
                                            email={email}
                                            setEmail={setEmail}
                                            getEmail={DoesEmailExist}
                                            touched={emailTouched}
                                            setTouched={setEmailTouched}
                                            className={{
                                                parentDiv: "",
                                                label: "block text-xs font-medium text-secondary",
                                                input:
                                                    "w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent",
                                            }}
                                        />

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Status<span className="text-red-500">*</span></label>
                                            <select
                                                value={statusId}
                                                onChange={(e) => setStatusId(Number(e.target.value))}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                            >

                                                {statusOptions.map((status: any, index: number) => (
                                                    <option key={index} value={status?.value}>
                                                        {status?.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>


                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Location<span className="text-red-500">*</span></label>
                                            <select
                                                value={locationId}
                                                onChange={(e) => setLocationId(Number(e.target.value))}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                            >

                                                {locationOptions.map((loc: any, index: number) => (
                                                    <option key={index} value={loc?.value}>
                                                        {loc?.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Address2</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={address2}
                                                placeholder="Address2"
                                                onChange={(e) => setAddress2(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">State<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={state}
                                                placeholder="State"
                                                onChange={(e) => setState(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Country<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={country}
                                                placeholder="Country"
                                                onChange={(e) => setCountry(e.target.value)}
                                                required
                                            />
                                        </div>


                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Tax ID</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={vendorTaxID}
                                                placeholder="Tax ID"
                                                onChange={(e) => setVendorTaxID(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Commission</label>
                                            <input
                                                type="number"
                                                min={0}
                                                step={0.01}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={commission}
                                                placeholder="Commission"
                                                onChange={(e) => setCommission(validateMin(e.target.value, 0))}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Contact Person 1</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={contactPerson1}
                                                placeholder="Contact Person 1"
                                                onChange={(e) => setContactPerson1(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Contact Person 2</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={contactPerson2}
                                                placeholder="Contact Person 2"
                                                onChange={(e) => setContactPerson2(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Website</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={website}
                                                placeholder="Website"
                                                onChange={(e) => setWebsite(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Default Ordering Mode</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={defaultOrderingMode}
                                                placeholder="Default Ordering Mode"
                                                onChange={(e) => setDefaultOrderingMode(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Default PO Delivery</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={defaultPODelivery}
                                                placeholder="Default PO Delivery"
                                                onChange={(e) => setDefaultPODelivery(e.target.value)}

                                            />
                                        </div>

                                    </div>

                                    {/* Second Column */}
                                    <div className="space-y-4">

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Phone Number<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                placeholder="Phone Number"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                required
                                                value={formatUSPhone(phone)}
                                                pattern="[\(][0-9]{3}[\)][\s]{1}[0-9]{3}[\-]{1}[0-9]{4}"
                                                title="Please Enter a 10 digits numbers."
                                                onChange={(e) => {
                                                    const digits = getUSPhoneDigits(e.target.value);
                                                    setPhone(digits);
                                                }}
                                            />
                                            {!isPhoneValid && (
                                                <div className="flex items-center gap-1 mt-2 text-xs text-red-500 ml-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 26 26"
                                                        strokeWidth={2}
                                                        stroke="currentColor"
                                                        className="w-4 h-4 text-red-500"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M12 9v3m0 3h.01m-9 0a9 9 0 1118 0 9 9 0 01-18 0z"
                                                        />
                                                    </svg>

                                                    <span>Please enter a valid 10-digit phone number</span>
                                                </div>
                                            )}
                                        </div>


                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Fax</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={fax}
                                                placeholder="Fax"
                                                onChange={(e) => setFax(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Address1<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={address1}
                                                placeholder="Address1"
                                                onChange={(e) => setAddress1(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">City<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={city}
                                                placeholder="City"
                                                onChange={(e) => setCity(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">County</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={county}
                                                placeholder="County"
                                                onChange={(e) => setCounty(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Zip Code</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={zipCode}
                                                placeholder="Zip Code"
                                                onChange={(e) => setZipCode(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Vendor Terms</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={vendorTerms}
                                                placeholder="Vendor Terms"
                                                onChange={(e) => setVendorTerms(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Rent</label>
                                            <input
                                                type="number"
                                                min={0}
                                                step={0.01}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={rent}
                                                placeholder="Rent"
                                                onChange={(e) => setRent(validateMin(e.target.value, 0))}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Contact Person 1 Phone</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={formatUSPhone(contactPerson1Phone)}
                                                placeholder="Contact Person 1 Phone"
                                                pattern="[\(][0-9]{3}[\)][\s]{1}[0-9]{3}[\-]{1}[0-9]{4}"
                                                title="Please Enter a 10 digits numbers."
                                                onChange={(e) => {
                                                    const digits = getUSPhoneDigits(e.target.value);
                                                    setContactPerson1Phone(digits);
                                                }}

                                            />
                                            {!isContact1PhoneValid && (
                                                <div className="flex items-center gap-1 mt-2 text-xs text-red-500 ml-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 26 26"
                                                        strokeWidth={2}
                                                        stroke="currentColor"
                                                        className="w-4 h-4 text-red-500"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M12 9v3m0 3h.01m-9 0a9 9 0 1118 0 9 9 0 01-18 0z"
                                                        />
                                                    </svg>

                                                    <span>Please enter a valid 10-digit phone number</span>
                                                </div>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Contact Person 2 Phone</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={formatUSPhone(contactPerson2Phone)}
                                                placeholder="Contact Person 2 Phone"
                                                pattern="[\(][0-9]{3}[\)][\s]{1}[0-9]{3}[\-]{1}[0-9]{4}"
                                                title="Please Enter a 10 digits numbers."
                                                onChange={(e) => {
                                                    const digits = getUSPhoneDigits(e.target.value);
                                                    setContactPerson2Phone(digits);
                                                }}

                                            />
                                            {!isContact2PhoneValid && (
                                                <div className="flex items-center gap-1 mt-2 text-xs text-red-500 ml-1">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 26 26"
                                                        strokeWidth={2}
                                                        stroke="currentColor"
                                                        className="w-4 h-4 text-red-500"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M12 9v3m0 3h.01m-9 0a9 9 0 1118 0 9 9 0 01-18 0z"
                                                        />
                                                    </svg>

                                                    <span>Please enter a valid 10-digit phone number</span>
                                                </div>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Minimum Order</label>
                                            <input
                                                type="number"
                                                min={0}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={minimumOrder}
                                                placeholder="Minimum Order"
                                                onChange={(e) => setMinimumOrder(validateMin(e.target.value, 0))}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Default Billable Department</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={defaultBillableDepartment}
                                                placeholder="Default Billable Department"
                                                onChange={(e) => setDefaultBillableDepartment(e.target.value)}

                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Delivery Time</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={deliveryTime}
                                                placeholder="Delivery Time"
                                                onChange={(e) => setDeliveryTime(e.target.value)}

                                            />
                                        </div>
                                    </div>
                                    {/* Buttons */}
                                    <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                        <button
                                            type="submit"
                                            className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                        >
                                            Save
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => navigate(-1)}
                                            className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => deletingVendor()}
                                            className="w-full sm:w-auto px-4 py-2 rounded bg-red-500 text-white cursor-pointer border border-red-600"
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </div>

                                <div className="p-2 w-[40%]">
                                    <div className="w-full px-2">

                                        <div className="mt-[16px]">
                                            <div className="flex items-center justify-between">
                                                <span className={`text-xs font-medium`}>Comments</span>

                                            </div>
                                            {
                                                saveCommentsValue && (
                                                    <div className="mt-[16px]">
                                                        {
                                                            saveCommentsValue.map((item: CommentType) => {
                                                                return (
                                                                    <AddComments
                                                                        id={item.id}
                                                                        userName={item.userName}
                                                                        createdDate={item.createdDate}
                                                                        notes={item.notes}
                                                                        deleteTheComment={(id) => deleteTheComment(id)}
                                                                    />
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                )
                                            }


                                            <div className="mt-[16px]">
                                                <textarea
                                                    className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                    rows={6}
                                                    value={comments}
                                                    onChange={(e) => setComments(e.target.value)}
                                                />
                                                <div className="mt-6">
                                                    <button
                                                        type="button"
                                                        onClick={() => saveComments()}
                                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                                    >
                                                        Save
                                                    </button>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}